import { Injectable } from '@angular/core';
import {OAuthToken} from "../../models/oauthtoken";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable()
export class UserStorageService {

  private static readonly TOKEN_KEY = "oauth_token";

  private storage: Storage = null;
  private _oauthToken: OAuthToken = null;
  private _tokenSubject: BehaviorSubject<OAuthToken>;

  constructor() {
    if (localStorage.getItem(UserStorageService.TOKEN_KEY) !== null) {
      this.storage = localStorage;
    } else if (sessionStorage.getItem(UserStorageService.TOKEN_KEY) !== null) {
      this.storage = sessionStorage;
    }
    if (this.storage !== null) {
      this._oauthToken = JSON.parse(this.storage.getItem(UserStorageService.TOKEN_KEY));
      this._oauthToken.refresh_date = new Date(this._oauthToken.refresh_date);
      this._tokenSubject = new BehaviorSubject(this._oauthToken);
    } else {
      this._tokenSubject = new BehaviorSubject(null);
    }
  }

  storeToken(oauthToken: OAuthToken, remember: boolean) {
    if (remember) {
      this.storage = localStorage;
    } else {
      this.storage = sessionStorage;
    }
    oauthToken.refresh_date = new Date();
    this._oauthToken = oauthToken;
    this.storage.setItem(UserStorageService.TOKEN_KEY, JSON.stringify(oauthToken));
    this._tokenSubject.next(oauthToken);
  }

  // only get, therefore readonly
  public get oauthToken() {
    return this._oauthToken;
  }

  public get token$(): Observable<OAuthToken> {
    return this._tokenSubject.asObservable();
  }

  clearToken() {
    if (this.storage === null) {
      throw new Error("no storage defined, User not logged in");
    }
    this.storage.removeItem(UserStorageService.TOKEN_KEY);
    this._oauthToken = null;
    this._tokenSubject.next(null);
  }

  updateToken(oauthToken: OAuthToken) {
    oauthToken.refresh_date = new Date();
    this.storage.setItem(UserStorageService.TOKEN_KEY, JSON.stringify(oauthToken));
    this._oauthToken = oauthToken;
  }
}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/services/authentication/user-storage.service.ts